import { AppRouteProps } from "@bsm/component";
import { StudentEducationNeedsAndDisabilitiesContainer } from "./container/StudentEducationNeedsAndDisabilitiesContainer";

export const StudentEducationNeedsAndDisabilitiesRoutes: Array<AppRouteProps> = [
    {
        path: "educationNeedsAndDisabilities",
        element: <StudentEducationNeedsAndDisabilitiesContainer />,
    },
];